export default __webpack_public_path__ + "static/media/summ-small-without-text-white.15aa87e0.png";